import _ from '@lodash';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import EmpresaPessoaApp from '../EmpresaPessoa/EmpresaPessoaApp';

class EmpresaFornecedorApp extends XAPPComponent {

    render() {
        var { xappRouteParams } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        return (
            <React.Fragment>
                <EmpresaPessoaApp
                    xappRouteParams={xappRouteParams}
                    label="Fornecedores"
                    target="spvwempresapessoafornecedor"
                    {...this.props}
                    defaultTipo={[4]}
                />
            </React.Fragment>
        )
    };
}


export default EmpresaFornecedorApp;
